import {
  UPDATE_GROUP,
} from './types';

/**
 *
 * @return {Function}
 */
const updateGroup = group => dispatch => {
  dispatch({ type: UPDATE_GROUP, payload: group });
};

export default {
  updateGroup,
};



// WEBPACK FOOTER //
// ./src/actions/group.js